<template>
  <header>

    <div class="collapse bg-dark" id="navbarHeader">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-md-7 py-4">
            <h4 class="text-white">À propos</h4>
            <p class="text-muted">{{`${totalDatabaseProblems} problèmes de mathématiques pour le cycle 2 et 3.`}}</p>
          </div>
          <div class="col-sm-4 offset-md-1 py-4">
            <ul class="list-unstyled">
              <li><a @click="$emit('login')" class="text-white" v-show="!isConnected">Se connecter</a></li>
              <li><a @click="$emit('logout')" class="text-white" v-show="isConnected">Se déconnecter</a></li>
              <li><a @click="open(null, 'Edit')" class="text-white" v-show="isConnected">Proposer un problème</a></li>
              <li v-if="isSystemAdmin"><router-link to="/system" class="text-white">Config système</router-link></li>
              <li><a href="https://arnaud-lierville.github.io/" target="_blank" class="text-white">Autres outils Maths en classe !</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar navbar-dark bg-dark shadow-sm">
      <div class="container">
        <a href="#" class="navbar-brand d-flex align-items-center">
          <img class="logo" :src="photoURL" v-show="photoURL">
          <strong>Problèmes en ligne</strong>
        </a>
        <div class="navbar-brand d-flex">
          <input class="form-control me-2 fix-margin-right" id="pbSearch" type="text" placeholder="numéro du problème" aria-label="Search" v-model="publicID" v-on:keyup.enter="handleSearch">
          <button class="btn btn-outline-info fix-margin-right" @click="handleSearch" :disabled="!publicID">Rechercher</button>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarHeader" aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
    </div>
    
  </header>
</template>

<script>

import { open } from '../utils'

export default {
  name: 'NavBar',
  props: {
    user: Object
  },
  data() {
    return {
      publicID: null,
      allProblems: [],
      isCheckingPassword: false
    }
  },
  firestore() {
    return { allProblems: this.db.collection('problems') }
  },
  methods: {
    open: open,
    async handleSearch() {
      if (!this.publicID) {
        return
      }

      // Store the value and clear the input immediately (before processing)
      const searchValue = this.publicID
      this.publicID = ''

      // If input is an integer, it's a problem number, not a password
      const inputAsNumber = parseInt(searchValue, 10)
      if (!isNaN(inputAsNumber) && inputAsNumber.toString() === searchValue.trim()) {
        // It's a number, search for the problem directly
        this.$emit('openProblem', searchValue)
        return
      }

      // If it's not a number, try to validate as password
      const isPassword = await this.checkPassword(searchValue)
      
      // If it was a valid password, don't search for a problem
      // (input is already cleared above)
      if (isPassword) {
        return
      }

      // If password check failed, still try to search for a problem (might be a non-numeric problem ID)
      this.$emit('openProblem', searchValue)
    },
    async checkPassword(password) {
      if (this.isCheckingPassword || !password) {
        return false
      }

      this.isCheckingPassword = true

      try {
        const projectId = 'live-problem'
        const functionUrl = `https://us-central1-${projectId}.cloudfunctions.net/requestAccess`

        const response = await fetch(functionUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            password: password
          })
        })

        if (response.ok) {
          const data = await response.json()
          // Store session ID in localStorage
          localStorage.setItem('aiSessionId', data.sessionId)
          localStorage.setItem('aiSessionExpires', data.expiresAt.toString())
          
          // Emit event to parent to show success modal
          this.$emit('ai-session-activated')
          
          return true // Password was valid
        }
        
        // 401 is expected when password is incorrect, don't log it
        if (response.status === 401) {
          return false // Password was invalid (silent failure)
        }
        
        // For other errors, silently return false
        return false
      } catch (error) {
        // Silently handle errors (network errors are usually temporary)
        return false
      } finally {
        this.isCheckingPassword = false
      }
    }
  },
  computed: {
    totalDatabaseProblems() {
      return this.allProblems.length
    },
    isConnected() {
      return this.user != null
    },
    photoURL() {
      let photoURL = null
      if (this.user) {photoURL = this.user.photoURL }
      return photoURL
    },
    isSystemAdmin() {
      return this.user && this.user.uid === 'LK1xQvX2RiY88Ta5XzfweXQ1pVK2'
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* bootstrap-vue fixing */
    .fix-margin-right {
        margin: 0px 8px 0px 0px;
    }
    .logo {
      width: 40px;
      margin-right: 16px;
      border-radius: 50%;
    }
</style>   